// src/App/Controllers/Accounting/Services/ApReport.js
// import dayjs from 'dayjs';

// const vendorNames = [
//   'Global Suppliers Inc.',
//   'Metro Wholesalers',
//   'Prime Distributors',
//   'United Industrial',
//   'Peak Materials Co.',
//   'Horizon Manufacturing',
//   'Summit Trading',
//   'Pioneer Imports',
//   'Elite Exporters',
//   'Nexus Logistics',
//   'Core Solutions Ltd.',
//   'Vertex Enterprises'
// ];

// export const get_ap_report = async ({ branch, from, to }) => {
//   // Generate mock data for vendors
//   const generateFakeVendor = (i) => {
//     const age_0_30 = Math.random() * 5000;
//     const age_31_60 = Math.random() * 4000;
//     const age_61_90 = Math.random() * 3000;
//     const age_90_plus = Math.random() * 2000;

//     return {
//       vendor_id: `ven_${i + 1}`,
//       vendor_name: vendorNames[i % vendorNames.length],
//       total_payable: age_0_30 + age_31_60 + age_61_90 + age_90_plus,
//       age_0_30,
//       age_31_60,
//       age_61_90,
//       age_90_plus,
//     };
//   };

//   const fakeData = Array.from({ length: 12 }, (_, i) => generateFakeVendor(i));

//   // Simulate network delay
//   return new Promise((resolve) => {
//     setTimeout(() => {
//       resolve(fakeData);
//     }, 300);
//   });
// };



//New UI services for AP Report
// src/App/Controllers/Accounting/Services/ApReport.js
// import dayjs from 'dayjs';

// const vendorNames = [
//   'Global Suppliers Inc.', 'Metro Wholesalers', 'Prime Distributors',
//   'United Industrial', 'Peak Materials Co.', 'Horizon Manufacturing',
//   'Summit Trading', 'Pioneer Imports', 'Elite Exporters',
//   'Nexus Logistics', 'Core Solutions Ltd.', 'Vertex Enterprises'
// ];

// const contactNames = [
//   'John Smith', 'Emily Johnson', 'Michael Brown',
//   'Sarah Davis', 'Robert Wilson', 'Jennifer Miller',
//   'David Anderson', 'Jessica Taylor', 'Christopher Thomas',
//   'Amanda Moore', 'James Jackson', 'Elizabeth White'
// ];

// const domains = ['gmail.com', 'yahoo.com', 'outlook.com', 'company.com', 'business.com'];

// export const get_ap_report = async ({ branch, vendorType, status, from, to }) => {
//   // Generate mock data for vendors
//   const generateFakeVendor = (i) => {
//     const age_0_30 = Math.random() * 5000;
//     const age_31_60 = Math.random() * 4000;
//     const age_61_90 = Math.random() * 3000;
//     const age_90_plus = Math.random() * 2000;
    
//     const vendorTypes = ['supplier', 'contractor', 'utility', 'service'];
//     const statuses = ['due', 'overdue', 'paid', 'pending'];
//     const paymentTerms = ['Net 30', 'Net 60', 'Due on Receipt', 'Net 15', '2/10 Net 30'];
    
//     const vendorTypeVal = vendorType !== 'all' ? vendorType : vendorTypes[Math.floor(Math.random() * vendorTypes.length)];
//     const statusVal = status !== 'all' ? status : statuses[Math.floor(Math.random() * statuses.length)];
    
//     // Generate contact info
//     const contactName = contactNames[i % contactNames.length];
//     const emailUser = contactName.toLowerCase().replace(' ', '.');
//     const domain = domains[Math.floor(Math.random() * domains.length)];
    
//     // Calculate due date (30-90 days in past or future)
//     const dueDateOffset = (statusVal === 'overdue' ? -1 : 1) * (30 + Math.floor(Math.random() * 60));
    
//     return {
//       vendor_id: `ven_${i + 1}`,
//       vendor_name: vendorNames[i % vendorNames.length],
//       vendor_type: vendorTypeVal,
//       total_payable: age_0_30 + age_31_60 + age_61_90 + age_90_plus,
//       age_0_30,
//       age_31_60,
//       age_61_90,
//       age_90_plus,
//       early_payment_discount: Math.random() > 0.7 ? Math.random() * 500 : 0,
//       payment_terms: paymentTerms[Math.floor(Math.random() * paymentTerms.length)],
//       status: statusVal,
//       due_date: dayjs().add(dueDateOffset, 'days').format('YYYY-MM-DD'),
//       contact_name: contactName,
//       contact_email: `${emailUser}@${domain}`,
//       contact_phone: `+1 (555) ${Math.floor(100 + Math.random() * 900)}-${Math.floor(1000 + Math.random() * 9000)}`,
//     };
//   };

//   // Filter based on parameters
//   const fakeData = Array.from({ length: 24 }, (_, i) => generateFakeVendor(i))
//     .filter(item => {
//       return (branch === 'all' || item.branch === branch) &&
//              (vendorType === 'all' || item.vendor_type === vendorType) &&
//              (status === 'all' || item.status === status);
//     });

//   // Simulate network delay
//   return new Promise((resolve) => {
//     setTimeout(() => {
//       resolve(fakeData);
//     }, 500);
//   });
// };


import axios from 'axios';

import APIURL from "../../../Main/apiurl";

const getAuthToken = () => localStorage.getItem("user");

const getAuthHeaders = () => {
  const token = getAuthToken();
  return token ? { Authorization: `Bearer ${token}` } : null;
};



export const get_ap_report = async ({ branch, vendorType, status, from, to }) => {
  try {
    const headers = getAuthHeaders();
    
    if (!headers) {
      throw new Error('Missing authentication token');
    }

    const params = {
      branch: branch || 'all',
      vendorType: vendorType || 'all',
      status: status || 'all',
      from,
      to
    };

    const response = await axios.get(`${APIURL}/ap-report`, {
      params,
      headers
    });

    if (response.data.success) {
      return response.data;
    } else {
      throw new Error(response.data.message || 'Failed to fetch AP report');
    }
  } catch (error) {
    console.error('AP Report API Error:', error);
    
    return await getMockAPReport({ branch, vendorType, status, from, to });
  }
};

const getMockAPReport = async ({ branch, vendorType, status, from, to }) => {
  const vendorNames = [
    'Alpha Suppliers', 'Beta Contractors', 'Gamma Utilities',
    'Delta Services', 'Epsilon Wholesalers', 'Zeta Distributors',
    'Theta Manufacturers', 'Omega Logistics', 'Sigma IT Services'
  ];

  const contactNames = [
    'John Smith', 'Maria Rodriguez', 'James Wilson',
    'Sarah Chen', 'Robert Brown', 'Jennifer Lee',
    'Thomas Johnson', 'Emily Davis', 'Christopher Martin'
  ];

  const domains = ['gmail.com', 'yahoo.com', 'outlook.com', 'company.com', 'business.com'];

  const generateFakeVendor = (i) => {
    const age_0_30 = Math.random() * 5000;
    const age_31_60 = Math.random() * 4000;
    const age_61_90 = Math.random() * 3000;
    const age_90_plus = Math.random() * 2000;
    
    const vendorTypes = ['supplier', 'contractor', 'utility', 'service'];
    const statuses = ['due', 'overdue', 'paid', 'pending'];
    const paymentTerms = ['Net 30', 'Net 60', 'Due on Receipt', '2/10 Net 30'];
    
    const vendorTypeVal = vendorType !== 'all' ? vendorType : vendorTypes[Math.floor(Math.random() * vendorTypes.length)];
    const statusVal = status !== 'all' ? status : statuses[Math.floor(Math.random() * statuses.length)];
    
    const contactName = contactNames[i % contactNames.length];
    const emailUser = contactName.toLowerCase().replace(' ', '.');
    const domain = domains[Math.floor(Math.random() * domains.length)];
    
    const dueDateOffset = (statusVal === 'overdue' ? -1 : 1) * (30 + Math.floor(Math.random() * 60));
    
    return {
      vendor_id: `ven_${i + 1}`,
      vendor_name: vendorNames[i % vendorNames.length],
      vendor_type: vendorTypeVal,
      total_payable: age_0_30 + age_31_60 + age_61_90 + age_90_plus,
      age_0_30,
      age_31_60,
      age_61_90,
      age_90_plus,
      early_payment_discount: Math.random() * 100,
      payment_terms: paymentTerms[Math.floor(Math.random() * paymentTerms.length)],
      status: statusVal,
      due_date: new Date(Date.now() + dueDateOffset * 24 * 60 * 60 * 1000).toISOString().split('T')[0],
      contact_name: contactName,
      contact_email: `${emailUser}@${domain}`,
      contact_phone: `+1 (555) ${Math.floor(100 + Math.random() * 900)}-${Math.floor(1000 + Math.random() * 9000)}`,
    };
  };

  const fakeData = Array.from({ length: 20 }, (_, i) => generateFakeVendor(i))
    .filter(item => {
      return (branch === 'all' || item.branch === branch) &&
             (vendorType === 'all' || item.vendor_type === vendorType) &&
             (status === 'all' || item.status === status);
    });

  return new Promise((resolve) => {
    setTimeout(() => {
      resolve(fakeData);
    }, 500);
  });
};